import { throttle } from "./Util";

const $parentWrap = $(".js-auto-height-child");
const $mobileRoundedWraps = $parentWrap.find(".technology-item");
const $wrapPage = $(".js-wrap-page");
let $children;
let cellHeight;

window.onload = function () {
    cellHeight = getCellWidth();

    if (App.W.outerWidth() < 768) {
        $mobileRoundedWraps.addClass("round-block");
    }

    $children = $parentWrap.find(">*:not(.not-round), .round-block");

    if ($parentWrap.length) {
        setTimeout(function () {
            roundBlocksHeights();
        }, 1000);

        App.W.on("resize", throttle(roundBlocksHeights, 500));
    }
};

/* Округляет высоты блоков до целой клетки, чтобы граница блока заканчивалась по клетке */
function roundBlocksHeights() {
    $children.removeAttr("style");

    cellHeight = getCellWidth();

    $children.each(function (index, el) {
        roundHeightForItem($(el), index);
    });
}

function roundHeightForItem($item) {
    const minCellCount = Math.ceil($item.outerHeight() / cellHeight);
    let delta = -2; // корректиция высота блока (?)

    if (App.D.outerWidth() > 1440) {
        delta = -3;
    }

    if (App.D.outerWidth() <= 640) {
        delta = 1.5;
    }

    /*if (App.D.outerWidth() > 1440) {
        delta = 1.5;
    }

    if (App.D.outerWidth() <= 1366) {
        delta = 2;
    }

    if (App.D.outerWidth() <= 1024) {
        delta = -1;
    }

    if (App.D.outerWidth() <= 640) {
        delta = 0;
    }*/

    //const minHeight = parseInt(minCellCount * cellHeight) + delta;
    // const minHeight = minCellCount * cellHeight + delta;
    const minHeight = minCellCount * cellHeight + delta;

    $item.css({
        minHeight: `${minHeight}px`,
    });
}

function getCellWidth() {
    //return App.D.outerWidth() / parseInt($wrapPage.data('cell-count'));
    return App.D.outerWidth() / parseFloat($wrapPage.data("cell-count"));
}



// WEBPACK FOOTER //
// ./_src/js/RoundBlockHeights.js